import http from './request'
// 中奖记录
export const getLotteryAmountRecordList = (data) => {
  return http({
    url: '/promotion/LotteryAmountRecord/getPagedList',
    method: 'post',
    data
  })
}

// 抽奖动作接口
export const doLotteryAction = (data) => {
  return http({
    url: '/promotion/CoinLottery/doAction',
    method: 'post',
    data
  })
}

// 获取轮播提现记录
export const getWithdrawList = (data) => {
  return http({
    url: '/promotion/CoinWithdraw/getList',
    method: 'post',
    data
  })
}

// 记录用户行为
export const recordBehavior = (data) => {
  return http({
    url: '/user/UserBehaviorRecord/recordBehavior',
    method: 'post',
    data
  })
}

// 获取授权码
export const getAuthCode = (data) => {
  return http({
    url: '/user/user/getAuthCode',
    method: 'post',
    data
  })
}
// 获取验证码 (登录用)
export const verifyCode = (data) => {
  return http({
    url: '/user/center/send/verifyCode',
    method: 'POST',
    data
  })
}
// 发送短信验证码 (添加银行卡用)
export const sendVerifyCode = (data) => {
  return http({
    url: '/user/guest/getVerifyCode',
    method: 'post',
    data
  })
}
// 数据上报通用接口
export const doAdsReport = (data) => {
  return http({
    url: '/transport/platform/doReport',
    method: 'post',
    data
  })
}
//获取通用配置
export const authCommonConfig = (data) => {
  return http({
    url: '/common/getConfig',
    method: 'post',
    data
  })
}

/**
 * 获取参数信息
 * @param {} shortParam
 * @returns
 */
export const getParamInfo = (data) => {
  return http({
    url: `/promotion/urlParamMapper/getParamInfo`,
    method: 'post',
    data
  })
}
// 获取实验结果
export const getAbTestType = (data) => {
  return http({
    url: '/bizBase/AbTestGroupUser/getInfo',
    method: 'post',
    data
  })
}
// 数据上报
export const appDataReport = (data) => {
  return http({
    url: '/transport/app/data/report/appDataReport',
    method: 'post',
    data
  })
}

// 通用弹窗
export const getCommonDialogInfo = (data) => {
  return http({
    url: '/promotion/DialogInfo/getInfo',
    method: 'post',
    data
  })
}
